// Soft UI Dashboard PRO React base styles

import colors from 'shared/theme/base/colors';

import borders from 'shared/theme/base/borders';

// Soft UI Dashboard PRO React helper functions

import rgba from 'shared/theme/functions/rgba';

import pxToRem from 'shared/theme/functions/pxToRem';

const { white } = colors;
const { borderRadius } = borders;

export default {
  styleOverrides: {
    root: {
      width: pxToRem(250),
      whiteSpace: 'nowrap',
      border: 'none',
    },

    paper: {
      width: pxToRem(250),
      backgroundColor: rgba(white.main, 0.8),
      backdropFilter: `saturate(200%) blur(${pxToRem(30)})`,
      height: `calc(100vh - ${pxToRem(32)})`,
      margin: pxToRem(16),
      borderRadius: borderRadius.xl,
      border: 'none',
    },

    paperAnchorDockedLeft: {
      borderRight: 'none',
    },
  },
} as const;
